import detail from "@/pages/officeApproval/approvalList/components/detail";
import popComment from "@/pages/officeApproval/approvalList/components/popComment.vue";
import mixinsPrint from '@/pages/officeApproval/approvalList/mixins/printPdf.js'
export default {
    mixins: [mixinsPrint],
  data() {
    return {
      status: '',
      detail: {},
      btnCommentLoading:false,
    }
  },
  components: {
      detail,popComment
  },
  computed: {
    isCollapsed() {
        return this.$store.state.isCollapsed
    }
  },
  created() {

  },
  activated() {
    this.status = ''
    this.detail = {}
  },
  methods: {
    returnToApprovals() {
      if (this.$root.desktopWorkbench && this.$route.query.fromChat === '1') {
        window.parent.postMessage({type:'hxt-approval-close'}, location.origin)
      } else this.$router.go(-1)
    },
    // 查看账号
    lookAccount() {
      let name = this.detail.businessName
      let id = this.detail.businessId
      if (!name || !id) return
      let pageName = `${name}Detail`
      const backMenuIndex = localStorage.getItem('selectedMenuIndex');
      localStorage.setItem('backMenuIndex', backMenuIndex);
      let newSelectedMenuIndex = `/assetManagement/${name}/list`
      localStorage.setItem('selectedMenuIndex',newSelectedMenuIndex);
      this.$router.push({
        name:pageName,
        query: {
          back:1,
          id,
        }
      })
    },
    // 查看公告
    lookAnnouncement() {
      console.log("查看公告", this.detail);
      
      let name = this.detail.businessName
      let id = this.detail.businessId
      if (!name || !id || name !== 'noticeDetail') return
      
      const backMenuIndex = localStorage.getItem('selectedMenuIndex');
      localStorage.setItem('backMenuIndex', backMenuIndex);
      let newSelectedMenuIndex = '/announcement/list'
      localStorage.setItem('selectedMenuIndex', newSelectedMenuIndex);
      this.$router.push({
        name: 'announcementDetail',
        query: {
          back: 1,
          id: id,
        }
      })
    },
    // 评论
    onComment() {
      this.$refs.popComment.show();
    },
    setComment(form) {
      this.btnCommentLoading = true;
      const postData = {
        processInstanceId: this.$route.query.id,
        comments: form.comments,
        imageUrls: form.imageUrls
      };
      // console.log("form", form);
      // return false;
      this.$api.workflowComments(postData).then((res) => {
        if (res.code === 0) {
          // this.$message.success("评论成功");
          this.$refs.detail.fetchData()
        }
      }).finally(()=>{
        this.btnCommentLoading = false
      })
    },
    // 监听返回的状态
    // setStatus(status) {
    //   this.status = status;
    // },
    setDetail(data) {
      this.detail = data;
      // status 1:正在处理 2:撤销 3:驳回 4:已结束
      // 我处理的页面才有上下一条的按钮
      if (this.$route.name ==='approvalManageDetail' && this.$route.query.fromChat !== '1') {
        this.getWorkflowNavigation()
      }else{
        this.buttonNavigation = {}
      }
    }

  }
}
